export default "__VITE_ASSET__DCF07UZV__"